import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/templates/Layout';
import { AuthGuard } from './components/AuthGuard';
import { Login } from './pages/Login';
import { SsoCallback } from './pages/sso/SsoCallback';
import { Home } from './pages/Home';
import { HomeNext } from './pages/HomeNext';
import { TitlesLayout } from './pages/titles/TitlesLayout';
import { TitlesGenres } from './pages/titles/TitlesGenres';
import { PlatformsLayout } from './pages/platforms/PlatformsLayout';
import { Leaderboard } from './pages/Leaderboard';
import { TitleProfile } from './pages/TitleProfile';
import { Platforms } from './pages/Platforms';
import { PlatformCatalog } from './pages/platforms/PlatformCatalog';
import { PlatformProfileLayout } from './pages/platforms/profile/PlatformProfileLayout';
import { SummaryTab } from './pages/platforms/profile/SummaryTab';
import { SubscribersTab } from './pages/platforms/profile/SubscribersTab';
import { RevenueTab } from './pages/platforms/profile/RevenueTab';
import { CatalogInsightsTab } from './pages/platforms/profile/CatalogInsightsTab';
import { PlatformProfilePrint } from './pages/platforms/profile/PlatformProfilePrint';
import { Workflows } from './pages/Workflows';
import { WorkflowCanvas } from './pages/WorkflowCanvas';

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path={'/login'} element={<Login />} />
      <Route path={'/sso/callback'} element={<SsoCallback />} />

      {/* PDF export — protected, but outside the app shell (no sidebar/header). */}
      <Route
        path={'/platforms/:id/pdf'}
        element={
          <AuthGuard>
            <PlatformProfileLayout print />
          </AuthGuard>
        }
      >
        <Route index element={<PlatformProfilePrint />} />
      </Route>

      {/* Protected routes */}
      <Route
        path={'/'}
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<HomeNext />} />
        <Route path={'home-next'} element={<HomeNext />} />
        {/* Legacy home — kept temporarily for comparison */}
        <Route path={'home-legacy'} element={<Home />} />

        {/* Titles universe — tabbed analyses under /titles/<analysis>. */}
        <Route path={'titles'} element={<TitlesLayout />}>
          <Route index element={<Navigate to={'/titles/leaderboard'} replace />} />
          <Route path={'leaderboard'} element={<Leaderboard />} />
          <Route path={'genres'} element={<TitlesGenres />} />
        </Route>
        {/* Title drill-through sits outside the tab shell. */}
        <Route path={'titles/:id'} element={<TitleProfile />} />
        {/* Old flat route → new tabbed home. */}
        <Route path={'leaderboard'} element={<Navigate to={'/titles/leaderboard'} replace />} />

        {/* Platforms universe — tabbed analyses under /platforms/<analysis>. */}
        <Route path={'platforms'} element={<PlatformsLayout />}>
          <Route index element={<Navigate to={'/platforms/leaderboard'} replace />} />
          <Route path={'leaderboard'} element={<Platforms />} />
          <Route path={'catalog'} element={<PlatformCatalog />} />
        </Route>
        {/* Platform drill-through sits outside the tab shell. */}
        <Route path={'platforms/:id'} element={<PlatformProfileLayout />}>
          <Route index element={<Navigate to={'summary'} replace />} />
          <Route path={'summary'} element={<SummaryTab />} />
          <Route path={'subscribers'} element={<SubscribersTab />} />
          <Route path={'revenue'} element={<RevenueTab />} />
          <Route path={'catalog-insights'} element={<CatalogInsightsTab />} />
          {/* Retired tabs: the quarterly table now opens Summary. */}
          <Route path={'content-value'} element={<Navigate to={'../catalog-insights'} replace />} />
          <Route path={'quarterly-data'} element={<Navigate to={'../summary'} replace />} />
        </Route>

        {/* Workflows — parameterised deliverables */}
        <Route path={'workflows'} element={<Workflows />} />
        <Route path={'workflows/new'} element={<WorkflowCanvas />} />
        <Route path={'workflows/:id'} element={<WorkflowCanvas />} />
        <Route path={'dashboards'} element={<Navigate to={'/workflows'} replace />} />
      </Route>
    </Routes>
  );
}
